import React, { useState } from "react";
import "./tree-style.css";
import addIcon from "../../assets/svg/add_icon_blue.svg";

export default function NodeCard({
  node,
  isLeaf,
  isFirstNode,
  addChild,
  removeNode,
  updateNode,
  statusList,
  nodeIndex,
  groupedError,
}) {
  const [lastKey, setLastKey] = useState("");

  const getErrorMsg = (index, field) => {
    if (field === "title") {
      if (groupedError[index] != null) {
        if (groupedError[index].title != null) {
          return (
            groupedError[index].title[0]?.replace(
              `milestoneflow.${index}.title`,
              "title"
            ) ?? ""
          );
        }
      }
    }

    if (field === "status") {
      if (groupedError[index] != null) {
        if (groupedError[index].status != null) {
          return (
            groupedError[index].status[0]?.replace(
              `milestoneflow.${index}.status`,
              "status"
            ) ?? ""
          );
        }
      }
    }
    if (field === "buffer_time") {
      if (groupedError[index] != null) {
        if (groupedError[index].buffer_time != null) {
          return (
            groupedError[index].buffer_time[0]?.replace(
              `milestoneflow.${index}.buffer_time`,
              "buffer_time"
            ) ?? ""
          );
        }
      }
    }
    if (field === "all") {
      if (groupedError[index] != null) {
        if (groupedError[index].all != null) {
          return (
            groupedError[index].all[0]?.replace(
              `milestoneflow.${index}.all`,
              "all"
            ) ?? ""
          );
        }
      }
    }
    if (field === "stoplevel") {
      if (groupedError[index] != null) {
        if (groupedError[index].stoplevel != null) {
          return (
            groupedError[index].stoplevel[0]?.replace(
              `milestoneflow.${index}.stoplevel`,
              "stoplevel"
            ) ?? ""
          );
        }
      }
    }

    if (field === "attachment") {
      if (groupedError[index] != null) {
        if (groupedError[index].attachment != null) {
          return (
            groupedError[index].attachment[0]?.replace(
              `milestoneflow.${index}.attachment`,
              "attachment"
            ) ?? ""
          );
        }
      }
    }

    if (field === "comment") {
      if (groupedError[index] != null) {
        if (groupedError[index].comment != null) {
          return (
            groupedError[index].comment[0]?.replace(
              `milestoneflow.${index}.comment`,
              "quantity"
            ) ?? ""
          );
        }
      }
    }

    if (field === "skip") {
      if (groupedError[index] != null) {
        if (groupedError[index].skip != null) {
          return (
            groupedError[index].skip[0]?.replace(
              `milestoneflow.${index}.skip`,
              "skip"
            ) ?? ""
          );
        }
      }
    }

    if (field === "signature") {
      if (groupedError[index] != null) {
        if (groupedError[index].signature != null) {
          return (
            groupedError[index].signature[0]?.replace(
              `milestoneflow.${index}.signature`,
              "signature"
            ) ?? ""
          );
        }
      }
    }
    return "";
  };

  return (
    <div className="node-card">
      {/* HEADER */}
      {isLeaf(node.box_id) && !isFirstNode() && (
        <button
          className="remove-btn"
          onClick={() => removeNode(node.box_id)}
          title="Remove"
        >
          −
        </button>
      )}

      <input
        className="title-input"
        placeholder="Title"
        value={node.title}
        onChange={(e) => updateNode(node.box_id, { title: e.target.value })}
      />
      <div className="fs-12 fw-400 cardTextRed">
        {getErrorMsg(nodeIndex, "title")}
      </div>
      <div className="controls-row mt-2">
        <select
          className="select-placeholder"
          defaultValue=""
          value={node.status}
          onChange={(e) => updateNode(node.box_id, { status: e.target.value })}
        >
          <option value="" disabled>
            Choose
          </option>
          {statusList.map((status) => (
            <option key={status.value} value={status.value}>
              {status.label}
            </option>
          ))}
        </select>

        <input
          type="text"
          className="time-input"
          value={node.buffer_time}
          onChange={(event) => {
            const inputText = event.target.value;
            console.log(inputText);
            if (/^[0-9:]*$/.test(inputText)) {
              if (/^\d{0,2}:?\d{0,2}$/.test(inputText)) {
                if (lastKey === "Backspace") {
                  updateNode(node.box_id, { buffer_time: inputText });
                } else {
                  updateNode(node.box_id, {
                    buffer_time:
                      inputText.length === 2 ? inputText + ":" : inputText,
                  });
                }
              }
            } else {
              updateNode(node.box_id, { buffer_time: node.buffer_time });
            }
          }}
          onKeyDown={(event) => {
            console.log(event.key);
            setLastKey(event.key);
          }}
        />
      </div>
      <div className="fs-12 fw-400 cardTextRed">
        {getErrorMsg(nodeIndex, "status")}
      </div>
      <div className="fs-12 fw-400 cardTextRed">
        {getErrorMsg(nodeIndex, "buffer_time")}
      </div>
      {/* SWITCHES */}
      <div className="mt-2  switch-widgets d-flex align-items-center justify-content-between">
        <div
          onClick={() => {
            updateNode(node.box_id, { all: !node.all });
          }}
          className="cursor-pointer switch-button d-flex align-items-center justify-content-start"
        >
          <div className="switch">
            <input
              type="checkbox"
              checked={node.all}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => {
                e.stopPropagation();
                updateNode(node.box_id, { all: e.target.checked });
              }}
            />
            <span className="switch-slider"></span>
          </div>
          <span className="ms-2 switch-label">ALL</span>
        </div>

        <div
          onClick={() => {
            updateNode(node.box_id, { stoplevel: !node.stoplevel });
          }}
          className="cursor-pointer switch-button d-flex align-items-center justify-content-start"
        >
          <div className="switch">
            <input
              type="checkbox"
              checked={node.stoplevel}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => {
                e.stopPropagation();
                updateNode(node.box_id, { stoplevel: e.target.checked });
              }}
            />
            <span className="switch-slider"></span>
          </div>
          <span className="ms-2 switch-label">Stop Level</span>
        </div>

        <div
          onClick={() => {
            updateNode(node.box_id, { attachment: !node.attachment });
          }}
          className="cursor-pointer switch-button d-flex align-items-center justify-content-start"
        >
          <div className="switch">
            <input
              type="checkbox"
              checked={node.attachment}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) =>
                updateNode(node.box_id, { attachment: !node.attachment })
              }
            />
            <span className="switch-slider"></span>
          </div>
          <span className="ms-2 switch-label">Attachment</span>
        </div>
      </div>
      <div className="fs-12 fw-400 cardTextRed">
        {getErrorMsg(nodeIndex, "all")}
      </div>
      <div className="fs-12 fw-400 cardTextRed">
        {getErrorMsg(nodeIndex, "stoplevel")}
      </div>
      <div className="fs-12 fw-400 cardTextRed">
        {getErrorMsg(nodeIndex, "attachment")}
      </div>
      <div className="mt-2 mb-3 switch-widgets d-flex align-items-center justify-content-between">
        <div
          onClick={() => {
            updateNode(node.box_id, { comment: !node.comment });
          }}
          className="cursor-pointer switch-button d-flex align-items-center justify-content-start"
        >
          <div className="switch">
            <input
              type="checkbox"
              checked={node.comment}
              onChange={(e) =>
                updateNode(node.box_id, { comment: !node.comment })
              }
            />
            <span className="switch-slider"></span>
          </div>
          <span className="ms-2 switch-label">Comment</span>
        </div>

        <div
          onClick={() => {
            updateNode(node.box_id, { skip: !node.skip });
          }}
          className="cursor-pointer switch-button d-flex align-items-center justify-content-start"
        >
          <div className="switch">
            <input
              type="checkbox"
              checked={node.skip}
              onChange={(e) => updateNode(node.box_id, { skip: !node.skip })}
            />
            <span className="switch-slider"></span>
          </div>
          <span className="ms-2 switch-label">Skip</span>
        </div>

        <div
          onClick={() => {
            updateNode(node.box_id, { signature: !node.signature });
          }}
          className="cursor-pointer switch-button d-flex align-items-center justify-content-start"
        >
          <div className="switch">
            <input
              type="checkbox"
              checked={node.signature}
              onChange={(e) =>
                updateNode(node.box_id, { signature: !node.signature })
              }
            />
            <span className="switch-slider"></span>
          </div>
          <span className="ms-2 switch-label">Signature</span>
        </div>
      </div>
      <div className="fs-12 fw-400 cardTextRed">
        {getErrorMsg(nodeIndex, "comment")}
      </div>
      <div className="fs-12 fw-400 cardTextRed">
        {getErrorMsg(nodeIndex, "skip")}
      </div>
      <div className="fs-12 fw-400 cardTextRed">
        {getErrorMsg(nodeIndex, "signature")}
      </div>
      {/* ADD CHILD */}
      <button
        className="add-btn"
        onClick={() => addChild(node.box_id)}
        title="Add Child"
      >
        <img src={addIcon} alt="add" />
      </button>
    </div>
  );
}
